import { HStack, Text, VStack } from '@chakra-ui/react';
import React from 'react';

interface Props {
  dots: { description: string; color: string }[];
  dotsGap?: string;
}

const ColoredDotsDescription = ({ dots, dotsGap = '40px' }: Props) => {
  return (
    <HStack gap={dotsGap} marginTop={'20px'}>
      {dots.map((dot) => (
        <HStack key={dot.description}>
          <VStack borderRadius={'50%'} width={'18px'} height={'18px'} backgroundColor={dot.color} />
          <Text variant={'urbanistBold16'} color={'text.mediumBlue'}>
            {dot.description}
          </Text>
        </HStack>
      ))}
    </HStack>
  );
};

export default ColoredDotsDescription;
